import { Pipe, PipeTransform } from '@angular/core';
import { CultureService } from '../culture/culture.service';

/// A product's name as this page shows it: the seller's own Bangla title on a Bangla page when there is one, else the name
/// as given - a product's name is never machine-translated (the owner, 2026-10-22). Takes the product (Name, NameBn).
export function productName(product: { Name?: string, NameBn?: string } | null, lang: string): string {
    if (!product) { return ''; }
    const bn = lang === 'bn' && product.NameBn ? String(product.NameBn).trim() : '';
    return bn || product.Name || '';
}

/// {{ product | productName }}
@Pipe({ name: 'productName' })
export class ProductNamePipe implements PipeTransform {
    constructor(private culture: CultureService) { }

    transform(product: { Name?: string, NameBn?: string } | null): string {
        return productName(product, this.culture.lang);
    }
}
